import { render } from "./orders.vue?vue&type=template&id=6f9d2f04&scoped=true"
const script = {}

import "./orders.vue?vue&type=style&index=0&id=6f9d2f04&lang=scss&scoped=true"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9d2f04"]])

export default __exports__